import * as XLSX from "xlsx";
import { asKpiLabel } from "./records";

export function buildCarrierSummary(records) {
  return records.reduce(
    (summary, record) => {
      summary.total += 1;
      if (record.kpiHit === true) summary.hit += 1;
      else if (record.kpiHit === false) summary.miss += 1;
      else summary.excluded += 1;

      const carrierSummary = summary.byCarrier[record.sourceCarrier] || {
        total: 0,
        hit: 0,
        miss: 0,
        excluded: 0,
      };
      carrierSummary.total += 1;
      if (record.kpiHit === true) carrierSummary.hit += 1;
      else if (record.kpiHit === false) carrierSummary.miss += 1;
      else carrierSummary.excluded += 1;
      summary.byCarrier[record.sourceCarrier] = carrierSummary;

      return summary;
    },
    {
      total: 0,
      hit: 0,
      miss: 0,
      excluded: 0,
      byCarrier: {},
    }
  );
}

export function exportCarrierResults(records) {
  const exportRows = records.map((record) => ({
    "Source Carrier": record.sourceCarrier,
    "Source Sheet": record.sourceSheet,
    "Consignment ID": record.consignmentId,
    "Carrier Despatch Date": record.carrierDespatchDate,
    "Carrier ETA": record.carrierEta,
    "Carrier Completed Date": record.carrierCompletedDate,
    "KPI Hit": asKpiLabel(record.kpiHit),
    "KPI Explanation": record.reconciledKpiExplanation,
    "Rule Applied": record.ruleApplied,
    "Raw Status": record.rawStatus,
    "Force Majeure Reason": record.forceMajeureReason,
    "Exclusion / ARC Category": record.exclusionCategory,
    "Exclusion / ARC Description": record.exclusionDescription,
    "Machship Despatch Date": record.machshipDespatchDate,
    "User Updated Despatch Date": record.userUpdatedDespatchDate,
    "Reconciled Despatch Date": record.reconciledDespatchDate,
    "Machship ETA": record.machshipEta,
    "User Updated ETA": record.userUpdatedEta,
    "Reconciled ETA": record.reconciledEta,
    "Machship Completed Date": record.machshipCompletedDate,
    "User Updated Completed Date": record.userUpdatedCompletedDate,
    "Reconciled Completed Date": record.reconciledCompletedDate,
    "Automated KPI Explanation": record.automatedKpiExplanation,
    "Carrier KPI Explanation": record.carrierKpiExplanation,
    "User Updated KPI Explanation": record.userUpdatedKpiExplanation,
    "Reconciled KPI Explanation": record.reconciledKpiExplanation,
    "Despatch Priority Source": record.despatchPrioritySource,
    "ETA Priority Source": record.etaPrioritySource,
    "Completed Priority Source": record.completedPrioritySource,
    "Explanation Priority Source": record.explanationPrioritySource,
    "Processed By": record.processedBy,
    "Processed At": record.processedAt,
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Carrier DIFOT");
  XLSX.writeFile(
    workbook,
    `Carrier_DIFOT_Integration_${new Date()
      .toISOString()
      .replace(/[:.]/g, "-")}.xlsx`
  );
}
